import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginLayoutComponent implements OnInit {

  constructor(
    public loaderService: LoaderService
  ) { }

  ngOnInit(): void {
  }

}
